import React from "react";
import MasonryGallery from "../components/MasonryGallery";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const CustomCursor = () => {
    const [position, setPosition] = React.useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = React.useState(false);

    React.useEffect(() => {
        const handleMouseMove = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
        };

        const handleMouseOver = (e) => {
            if (e.target.closest("button, a, .cursor-hover")) {
                setIsHovering(true);
            } else {
                setIsHovering(false);
            }
        };

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseover", handleMouseOver);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseover", handleMouseOver);
        };
    }, []);

    return (
        <div
            className="fixed pointer-events-none z-[9999] mix-blend-difference hidden md:block"
            style={{
                left: position.x,
                top: position.y,
                transform: "translate(-50%, -50%)",
            }}
        >
            <div
                className={`rounded-full bg-white transition-all duration-300 ease-out ${
                    isHovering ? "w-7 h-7 opacity-50" : "w-3 h-3 opacity-100"
                }`}
            />
        </div>
    );
};

const BennyVyshnavi = () => {
    const images = [
        "/assets/wedding/Benny_Vaishnavi_webp/w1.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w2.webp",
        "https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/wedding/Benny_Vaishnavi/w3.jpg",
        "/assets/wedding/Benny_Vaishnavi_webp/w4.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w5.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w6.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w7.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w8.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w9.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w10.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w11.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w12.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w13.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w14.webp",
        "https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/wedding/Benny_Vaishnavi/w15.jpg",
        "/assets/wedding/Benny_Vaishnavi_webp/w16.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w17.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w18.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w19.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w20.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w21.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w22.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w23.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w24.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w25.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w26.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w27.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w28.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w29.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w30.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w31.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w32.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w33.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w34.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w35.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w36.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w37.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w38.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w39.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w40.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w41.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w42.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w43.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w44.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w45.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w46.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w47.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w48.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w49.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w50.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w51.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w52.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w53.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w54.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w55.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w56.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w57.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w58.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w59.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w60.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w61.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w62.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w63.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w64.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w65.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w66.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w67.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w68.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w69.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w70.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w71.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w72.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w73.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w74.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w75.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w76.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w77.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w78.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w79.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w80.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w81.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w82.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w83.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w84.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w85.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w86.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w87.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w88.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w89.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w90.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w91.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w92.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w93.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w94.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w95.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w96.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w97.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w98.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w99.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w100.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w101.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w102.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w103.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w104.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w105.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w106.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w107.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w108.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w109.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w110.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w111.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w112.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w113.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w114.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w115.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w116.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w117.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w118.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w119.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w120.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w121.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w122.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w123.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w124.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w125.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w126.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w127.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w128.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w129.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w130.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w131.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w132.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w133.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w134.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w135.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w136.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w137.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w138.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w139.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w140.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w141.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w142.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w143.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w144.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w145.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w146.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w147.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w148.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w149.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w150.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w151.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w152.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w153.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w154.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w155.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w156.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w157.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w158.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w159.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w160.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w161.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w162.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w163.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w164.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w165.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w166.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w167.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w168.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w169.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w170.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w171.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w172.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w173.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w174.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w175.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w176.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w177.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w178.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w179.webp",
        "/assets/wedding/Benny_Vaishnavi_webp/w180.webp",
    ];

    return (
        <div className="bg-neutral-950 min-h-screen" style={{ cursor: "none" }}>
            <CustomCursor />
            <Navigation />
            <MasonryGallery
                title="Benny & Vyshnavi"
                subtitle="TUSCANY, ITALY — DESTINATION WEDDING"
                images={images}
            />

            <Footer />
        </div>
    );
};

export default BennyVyshnavi;
